@if (spec) {
    @if (!hasTotalField()) {
        <div class="empty-title" soho-emptymessage
             [info]="'AddColumnOrSummaryTotal' | translate">
        </div>
    } @else {
        <div class="lm-builder-total-operators">
            <input
                soho-checkbox
                type="checkbox"
                id="lm-builder-show-totals-only"
                data-automation-id="lm-builder-show-totals-only"
                [(ngModel)]="spec.showTotalsOnly"
                [disabled]="false">
            <label soho-label for="lm-builder-show-totals-only" [forCheckBox]="true" data-automation-id="lm-builder-show-totals-only-label" class="lm-checkbox-label" soho-tooltip [content]="'TotalsOnlyTooltip' | translate">{{ 'TotalsOnly' | translate }}</label>
            <input
                soho-checkbox
                type="checkbox"
                id="lm-builder-suppress-sub-totals"
                data-automation-id="lm-builder-suppress-sub-totals"
                [(ngModel)]="spec.suppressSubtotals"
                [disabled]="false">
            <label soho-label for="lm-builder-suppress-sub-totals" [forCheckBox]="true" data-automation-id="lm-builder-column-total-label" class="lm-checkbox-label" soho-tooltip [content]="'SuppressSubtotalsTooltip' | translate">{{ 'SuppressSubtotals' | translate }}</label>
        </div>
        <div class="lm-builder-total-header-info">
            <p>{{ 'SubtotalsAppearAtGroupBreaks' | translate }}</p>
        </div>
        @for (totalBy of totalByInfoList(); track totalBy; let i = $index) {
            <div class="invoice-config-card">
                <div class="lm-flex-row-container-space-between">
                    <span attr.data-automation-id="lm-builder-total-by-{{!totalBy.name}}-{{i}}" class="lm-bold lm-font-sm lm-tooltip-on-truncate" soho-tooltip [content]="totalBy.sortOrder">{{totalBy.name}}</span>
                    @if (totalBy.default) {
                        <span attr.data-automation-id="lm-builder-total-by-default-tag-{{!totalBy.name}}-{{i}}" class="tag good lm-padding-right">{{'Default' | translate}}</span>
                    }
                </div>
                <div class="card-header">
                    <div class="field-col font-size-xs" soho-tooltip [content]="'FieldID' | translate">{{ 'FieldID' | translate }}</div>
                    <div class="option-col font-size-xs" soho-tooltip [content]="'SubtotalHeader' | translate">{{ 'SubtotalHeader' | translate }}</div>
                    <div class="option-col font-size-xs" soho-tooltip [content]="'PageBreakHeader' | translate">{{ 'PageBreakHeader' | translate }}</div>
                </div>
                @for (subTotalInfo of totalBy.subTotalBy; track subTotalInfo; let j = $index) {
                    <div class="card-row">
                        <div class="field-col font-size-xs" soho-tooltip [content]="subTotalInfo.field">{{subTotalInfo.field}}</div>
                        <div class="option-col font-size-xs">
                            <input attr.data-automation-id="lm-builder-total-by-enabled-checkbox-{{!totalBy.name}}-{{i}}-{{subTotalInfo.field}}"
                                   type="checkbox"
                                   soho-checkbox
                                   id="lm-builder-total-by-enabled-checkbox-{{!totalBy.name}}-{{i}}-{{subTotalInfo.field}}"
                                   name="lm-builder-total-by-enabled-checkbox-{{!totalBy.name}}-{{i}}-{{subTotalInfo.field}}"
                                   soho-tooltip [content]="subTotalInfo.field"
                                   [disabled]="spec.suppressSubtotals || !hasTotalField() || totalBy.subTotalBy.length < 2 || (subTotalInfo.enabled && totalBy.disable)"
                                   [(ngModel)]="subTotalInfo.enabled"
                                   (change)="onColumnSubTotalByChanged(totalBy)"
                            >
                            <label attr.data-automation-id="lm-subtotal-by-widget-field-name-{{totalBy.name}}-{{i}}-{{subTotalInfo.field}}"
                                   soho-tooltip [content]="'Uncheck to turn off subtotal for ' + subTotalInfo.field" [forCheckBox]=true soho-label for="lm-builder-total-by-enabled-checkbox-{{!totalBy.name}}-{{i}}-{{subTotalInfo.field}}">
                            </label>
                        </div>
                        <div class="option-col font-size-xs">
                            <input attr.data-automation-id="lm-builder-total-by-page-break-checkbox-{{totalBy.name}}-{{i}}-{{subTotalInfo.field}}"
                                   type="checkbox"
                                   soho-checkbox
                                   id="lm-builder-total-by-page-break-checkbox-{{totalBy.name}}-{{i}}-{{subTotalInfo.field}}"
                                   name="lm-builder-total-by-page-break-checkbox-{{totalBy.name}}-{{i}}-{{subTotalInfo.field}}"
                                   [disabled]="!subTotalInfo.enabled || spec.suppressSubtotals || !hasTotalField()"
                                   [(ngModel)]="subTotalInfo.pageBreak"
                                   (change)="onColumnSubTotalByChanged(totalBy)">
                            <label
                                    soho-label
                                    [forCheckBox]=true
                                    soho-tooltip [content]="'Check to start a new PDF page at each break in ' + subTotalInfo.field"
                                    for="lm-builder-total-by-page-break-checkbox-{{totalBy.name}}-{{i}}-{{subTotalInfo.field}}">
                            </label>
                        </div>
                    </div>

                }

            </div>
        }
    }
}
